var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"loading":_vm.loading,"color":"blue","small":"","depressed":"","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.onClickPrint.apply(null, arguments)}}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("mdi-printer")]),_vm._v(" "+_vm._s(_vm.$t("global.print"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }